export const API_BASE = process.env.VUE_APP_API_BASE;
// export const API_BASE = "https://api.explorethelocal.com/graphql";
